import { IViewProduct } from "../../../interfaces-and-types";

import imagePlaceholder from "../../../assets/icons/img-placeholder.svg";
import { CurrencyDisplay } from "../../../components";

export const SelectedProductDisplay = (props: { product: IViewProduct }) => {
  const { product } = props;

  return (
    <div className="flex-container selected-product--container">
      <div className="product-logo--container">
        <img
          src={product.product_icon ?? imagePlaceholder}
          alt="product icon"
          className="payment-link--product-icon"
        />
      </div>

      <div className="flex-box">
        <div className="">{product.product_name}</div>
        <div className="">
          <CurrencyDisplay
            currencyOrSymbol={product.currency}
            amount={product.price}
            amountFontSize={14}
            symbolFontSize={12}
          />
        </div>
      </div>
    </div>
  );
};
